import React, { useEffect, useState } from "react";
// import Layout from '@/layouts/authenticated';
import { Head } from '@inertiajs/react';

console.log('test')

export default function Products({ user }) {
    return (
        <div>
            <h1>Welcome</h1>
        </div>
    )
}